import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { useNotify } from "_common/component/NotifyProvider";
import { Link, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PriceApi } from "states/api/price";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";

import GameBoard from "./GameBoard";
import HistoryPrice from "./HistoryPrice";

const Contract1 = observer(({ game_id }) => {
  const {
    authStore: { games, user },
  } = useStores();

  const { updatePrice } = useNotify();

  const [params] = useSearchParams();
  const direction = params?.get("direction") || "buy";

  const { data: dataPrice, refetch: getPrice } = useQuery(
    ["prices", "list"],
    () =>
      PriceApi.getList({
        params: {
          page: 1,
          limit: 10,
        },
      }),
    {
      staleTime: 300000,
    }
  );

  const priceBtc = useMemo(
    () => dataPrice?.find((obj) => obj?.symbol === game_id?.toUpperCase()),
    [dataPrice, game_id]
  );

  const mainCoin = useMemo(
    () => games?.find((obj) => obj?.code === game_id),
    [games, game_id]
  );

  useEffect(() => {
    const interval = setInterval(() => {
      getPrice();
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (!priceBtc?.lastPrice) return;
    updatePrice({ user_id: user?.id, lastPrice: priceBtc?.lastPrice });
  }, [priceBtc?.lastPrice, user]);

  return (
    <div>
      <div className="flex justify-between" style={{ border: "none" }}>
        <div className="content_title_l tleft flex items-center gap-3 px-4">
          <span className="leading-[20px] text-[18px] ">
            <FontAwesomeIcon icon={faCog} className="text-green" />
          </span>
          <span className="text-uppercase text-[18px] leading-[20px]">
            {mainCoin?.name}
          </span>
        </div>
      </div>
      <div className="grid grid-cols-12 p-4">
        <div className="col-span-7">
          <GameBoard
            mainCoin={mainCoin}
            game_id={game_id}
            data_price={priceBtc}
            direction={direction}
          />
        </div>
        <div className="col-span-5 ml-4">
          <HistoryPrice />
        </div>
      </div>
    </div>
  );
});

export default Contract1;
